<template>
  <v-snackbar v-model="isShown" :timeout="timeout || -1" z-index="5000" location="right" class="error-message">
    <div class="error-message__header">
      <e-icon v-if="isError" name="closeCircle" class="text-red mr-4" />
      <e-icon v-else name="info" class="text-yellow mr-4" />
      <div>
        <slot name="title">
          <div class="paragraph-m_h font-600">
            {{ title }}
          </div>
        </slot>
        <div class="paragraph-s_h text-secondary mt-1">
          <slot name="subtitle">
            {{ subtitle }}
          </slot>
        </div>
      </div>
      <v-spacer />
      <e-btn icon size="S" class="error-message__close" @click="close">
        <e-icon name="closeSvg" :size="16" />
      </e-btn>
    </div>

    <slot />
  </v-snackbar>
</template>

<script setup lang="ts">
import { EBtn, EIcon } from '@/core/components/ui';

defineProps<{
  isError: boolean;
  timeout?: number;
  title: string;
  subtitle?: string;
}>();

defineSlots<{
  default: (props: unknown) => void;
  title?: (props: unknown) => void;
  subtitle?: (props: unknown) => void;
}>();

const emit = defineEmits<{
  (event: 'close'): void;
}>();

const isShown = defineModel<boolean>({ required: true });

const close = () => {
  isShown.value = false;
  emit('close');
};
</script>

<style scoped lang="scss">
.error-message {
  margin: 16px;

  &:deep(.v-overlay__content) {
    width: 100%;
    max-width: 640px;
  }

  &:deep(.v-snackbar__content) {
    width: 100%;
    padding: 24px;

    color: $text-primary-color;
  }

  &__header {
    display: flex;
    align-items: flex-start;
  }

  &__close {
    margin-top: -6px;
    margin-right: -4px;
  }
}
</style>
